export var ExternalFileKind;
(function (ExternalFileKind) {
    ExternalFileKind["SINGLE_OBJECT"] = "SingleObjectFile";
    ExternalFileKind["HTTP_LINK"] = "HttpLinkFile";
})(ExternalFileKind || (ExternalFileKind = {}));
